var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%"},style:({ 'background-color': _vm.$vuetify.theme.themes.light.backgroundHome })},[_c('Dirigentes',{staticStyle:{"height":"100%"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }